import React, { useState } from 'react';
import styled from 'styled-components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Spin } from 'antd';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  background-color: #fff;
  padding: 16px;
`;
const Name = styled.div`
  color: #000;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 107.692% */
  padding-right: 8px;
`;
const Title = ({ content, loading }) => {
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };
  return (
    <Wrapper>
      {loading ? <Spin /> : <Name>{content}</Name>}
      <QuestionCircleOutlined onClick={showModal} style={{ fontSize: '14px', color: '#777777' }} />
      <Modal
        title="What is an Experience Alert?"
        open={open}
        onOk={hideModal}
        onCancel={hideModal}
        footer={[
          <Button key="ok" ghost type="primary" onClick={hideModal}>
            Ok
          </Button>,
        ]}
      >
        <p>
          You will find an incident summary and impact details to the suspected root cause and
          diagnosis to your Experience Alert. You’ll also be able to further investigate the
          incident using Trends for each of the layers of your application stack.
        </p>
      </Modal>
    </Wrapper>
  );
};

export default Title;
